//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'

//#endregion


import { LocalDictionaryFactory } from '../../api/api.module'
import { ColumnModel } from '../../api/api.models'

import { DataTypeGroupComponent, EventsNames, OperatorLayoutSettings, IUserSession, LocalizationHelper, TemplateHelper, ConfigHelper, LogHelper } from '../../../helpers/'

import { Details, DetailsScope, DetailsAccordion, DetailsAccordionSection } from '../../common/common.details'
import { DetailsParametersOptions } from '../../common/details-parameters/details-parameters.directive'
import { DetailsPopupOptions, DetailsOptions } from '../../common/details-popup/details-popup.directive'
import { GridBridge } from '../../common/common.interfaces'
import { GridOptions, GridTypes, GridController } from '../../common/grid/grid.controller'
import { LoggerService } from '../../common/common.module'

import { Activity, Enums } from '../../../models/common/'
import { OpDataTypeInGroup, OpOperatorGroup, OpOperator, OpTechnicalPermission } from '../../../models/core/'
import { SESSION } from '../../../models/custom/'

import { IIMRParameters, IMRParametersOptions, IMRParametersInitializedArgs } from '../../common/parameters'

import { GridService } from '../../../services/grid'
import { IBasicParametersExtension, BasicParametersExtension, BasicParameter } from '../../common/parameters/extensions'
import { OperatorGroupTechnicalPermissionsService, OperatorGroupOperatorsService } from '../../../services/operator-group'
import { ReferenceTypeService } from '../../../services/reference-type'
import { TechnicalPermissionService } from '../../../services/technical-permission'

import { OperatorGroupHelper } from '../operator-group-helper'

interface OperatorGroupScope extends DetailsScope {
    OPERATOR_GROUP_COMMON_TAB_NAME: string
    OPERATOR_GROUP_ACCORDION_GRID_NAME: string
    OPERATOR_GROUP_PARAMS_ACCORDION_NAME: string
    OPERATOR_GROUP_REQUIRED_TECHNICAL_PERMISSIONS_ACCORDION_NAME: string

    id: number

    detailsParametersOptions: DetailsParametersOptions
    noActiveAccordions: string
    noDefinedContent: string
    operatorsGridOptions: GridOptions
    operatorGroupGridEditOptions: GridBridge
    requiredTechnicalPermissionsGridOptions: GridOptions
    requiredTechnicalPermissionsGridEditOptions: GridBridge
    deleteConfirmationOptions: {
        title: string

        onConfirmed: () => void
    }

    availableTechnicalPermissionsParameters: IIMRParameters<IBasicParametersExtension>
    availableTechnicalPermissionsParametersOptions: IMRParametersOptions<IBasicParametersExtension>
}

export class OperatorGroupDetailsController extends Details<OperatorGroupScope> {

    // #region Consts

    private get OPERATOR_GROUP_GRID_NAME() { return 'OperatorGroupDetails' }
    private get REQUIRED_TECHNICAL_PERMISSIONS_GRID_NAME() { return 'RequiredTechnicalPermissionsGrid' }
    private get OPERATOR_GROUP_GRID_EDIT_NAME() { return 'OperatorGroupGridEdit' }
    private get REQUIRED_TECHNICAL_PERMISSIONS_GRID_EDIT_NAME() { return 'RequiredTechnicalPermissionsGridEdit' }


    // #endregion


    // #region Members

    private referenceObject: OpOperatorGroup
    private referenceObjectId: number
    private operators: OpOperator[]
    private columns: ColumnModel[]
    private requiredTechnicalPermissionsEditGrid: GridController<OpTechnicalPermission>

    // #endregion


    // #region Ctor

    constructor(
        $scope: OperatorGroupScope,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        protected userSession: IUserSession,
        private gridService: GridService,
        private technicalPermissionService: TechnicalPermissionService,
        private referenceTypeService: ReferenceTypeService,
        private opreatorGroupOperatorsService: OperatorGroupOperatorsService,
        private operatorGroupTechnicalPermissionsService: OperatorGroupTechnicalPermissionsService,
        protected referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super($scope, $timeout, $q, logger, localDictionary, OperatorLayoutSettings.ContactPopupTabActive, userSession, referenceType)
        this.setConfirmationsOptions()
        this.setEvents()
        this.setOptions()
        this.setTemplateConsts()
        this.getColumns()

        if (this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_GROUP_LIST)) {
            this.configureTabs(this.getTabs())
        }
    }

    // #endregion


    // #region Events

    private getColumns(): void {
        this.gridService
            .getColumnModelByCategory(
                Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__OPERATOR_GRID_PARAMS,
                this.moduleName, { viewReferenceType: Enums.ReferenceType.IdOperator }
            )
            .then((columns: ColumnModel[]) => {
                this.columns = columns
            })

    }

    private onOpen(options: DetailsOptions): void {
        this.$scope.detailsOpenParams = options
        this.referenceObjectId = options.referenceObjectId

        this.onClear()
        this.showPopup()
        this.initialize()
    }

    private initialize() {
        const deferred: JQueryDeferred<OpOperatorGroup> = $.Deferred<OpOperatorGroup>()

        this.userSession
            .getDataProvider().OperatorGroup
            .getOperatorGroup(this.referenceObjectId)
            .then((result: OpOperatorGroup) => {
                this.$scope.popupTitle = result.toString()
                this.operators = result.currentOperators
                deferred.resolve(result)
            })
            .fail((error: any) => {
                let errorMsg: string = error

                if (SESSION.isType(error)) {
                    errorMsg = (<SESSION>error).toString()
                }

                LogHelper.error(OperatorGroupHelper.LOG_PREFIX, errorMsg)
                deferred.resolve(null)
            })
            .always(() => {
                this.$scope.showTabs = true
            })

        deferred
            .promise()
            .then((result: OpOperatorGroup) => {
                if (result != null && (this.referenceObject == null || this.referenceObject.idOperatorGroup == result.idOperatorGroup)) {
                    this.referenceObject = result
                    this.operators = result.currentOperators

                    this.setOperatorsGridOptions(result.currentOperators)
                    this.setOperatorGroupGridEditOptions(result.currentOperators)

                    if (!this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_GROUP_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.OperatorGroupTechnicalPermissions)) {
                        this.initializeAvailableTechnicalPermissionsParameters(result.currentOperators)
                    }

                    this.getOperatorGroupDataType()
                    this.setRequiredTechnicalPermissionsGridOptions(result.technicalPermissions)
                    this.setRequiredTechnicalPermissionsGridEditOptions(result.technicalPermissions)

                }
            })
    }

    private onRefresh(toRefresh: OpOperatorGroup): void {
        if (toRefresh != null && (this.referenceObject == null || this.referenceObject.idOperatorGroup == toRefresh.idOperatorGroup)) {
            this.referenceObject = toRefresh
            this.operators = toRefresh.currentOperators

            this.setOperatorsGridOptions(toRefresh.currentOperators)
            this.setOperatorGroupGridEditOptions(toRefresh.currentOperators)
            this.updateAvailableTechnicalPermissionsParameters(toRefresh.currentOperators)

            this.getOperatorGroupDataType()
            this.setRequiredTechnicalPermissionsGridOptions(toRefresh.technicalPermissions)
            this.setRequiredTechnicalPermissionsGridEditOptions(toRefresh.technicalPermissions)
        }
    }

    private getOperatorGroupDataType(): void {
        DataTypeGroupComponent
            .getDataTypeInGroupByModule(
                this.userSession.getDataProvider(),
                Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__PANEL_PARAMS_TO_DISPLAY,
                this.moduleName
            )
            .then((dataTypeInGroup: OpDataTypeInGroup[]) => {
                this.setOperatorGroupBasicParametersOptions(dataTypeInGroup)
            })
    }

    private onClear(): void {
        this.$scope.popupTitle = ''
        this.$scope.showTabs = false

        this.referenceObject = null
        this.$scope.detailsParametersOptions = null
        this.$scope.operatorsGridOptions = null
        this.$scope.operatorGroupGridEditOptions = null
        this.$scope.requiredTechnicalPermissionsGridOptions = null
        this.$scope.requiredTechnicalPermissionsGridEditOptions = null
    }

    private onClose(): void {
        this.$scope.operatorsGridOptions = null
        this.$scope.requiredTechnicalPermissionsGridOptions = null
        this.hidePopup()
    }

    private onConfirmDelete(): void {

        OperatorGroupHelper
            .deleteOperatorGroup(this.userSession.getDataProvider(), this.referenceObject, this.moduleName)
            .then(() => {
                this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName))
                this.onClose()
            })
            .fail((error: any) => {
                LogHelper.error(OperatorGroupHelper.LOG_PREFIX, error)
            })
    }

    private onDelete(): void {
        this.$scope.$broadcast(
            EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.detailsPopupId,
            LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONFIRM_DELETE, this.moduleName)
        )
    }

    // #endregion


    // #region Accordions

    public getAccordions(): DetailsAccordion[] {
        const accordions: DetailsAccordion[] = []
        let items: DetailsAccordionSection[] = []

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_GROUP_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.OperatorGroupParameters)) {
            items.push({
                name: this.$scope.OPERATOR_GROUP_PARAMS_ACCORDION_NAME,
                showInTab: this.$scope.OPERATOR_GROUP_COMMON_TAB_NAME,
                showStatus: false,
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.BasicParameters),
                visible: true,
                canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_GROUP_EDIT)
                    && !this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_GROUP_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.OperatorGroupParameters),
                editMethod: () => this.onEditOperatorGroupBasicParams()
            })
        }

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_GROUP_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.OperatorGroupTechnicalPermissions, true)) {
            items.push({
                name: this.$scope.OPERATOR_GROUP_REQUIRED_TECHNICAL_PERMISSIONS_ACCORDION_NAME,
                showInTab: this.$scope.OPERATOR_GROUP_COMMON_TAB_NAME,
                showStatus: false,
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RequiredTechnicalPermissions),
                visible: true,
                canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_GROUP_EDIT)
                    && !this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_GROUP_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.OperatorGroupTechnicalPermissions),
                editMethod: () => this.onEditRequiredTechnicalPermissions()
            })
        }

        accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.ContactDetailsAccordions, 0, items, true, (component: DevExpress.ui.dxAccordion) => {
            this.$timeout(() => {
                component.expandItem(1)
                component.expandItem(2)
            })
        }))

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.OperatorGroupOperators)) {
            items = []
            items.push({
                name: this.$scope.OPERATOR_GROUP_ACCORDION_GRID_NAME,
                showInTab: this.$scope.OPERATOR_GROUP_COMMON_TAB_NAME,
                showStatus: true,
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Operators),
                visible: true,
                canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_GROUP_EDIT)
                    && !this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_GROUP_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.OperatorGroupOperators),
                editMethod: () => this.onEditOperatorGroup(),
                status: () => LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AssignedCount) + _.size(this.operators).toString()
            })

            accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.ContactDetailsAccordions, 1, items))
        }

        return accordions
    }

    // #endregion


    // #region Tabs

    public getTabs(): any[] {
        return [{
            template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Common), ConfigHelper.Icon.HOME, this.userSession),

            name: this.$scope.OPERATOR_GROUP_COMMON_TAB_NAME
        }]
    }

    // #endregion


    // #region Available Technical Permissions Parameters

    private setAvailableTechnicalPermissionsBasicParameter(operators: OpOperator[]): BasicParameter {
        const operatorGroupTechnicalPermissionsSummary: string = this.operatorGroupTechnicalPermissionsService.createOperatorGroupTechnicalPermissionsSummary(operators)
        const availableTechnicalPermissionsValue: string = operatorGroupTechnicalPermissionsSummary.length > 0 ?
            operatorGroupTechnicalPermissionsSummary :
            LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoAssignedTechnicalPermissions)
        const availableTechnicalPermissionsParameter: BasicParameter = {
            caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AvailableTechnicalPermissions),
            value: availableTechnicalPermissionsValue,
            isHTML: true
        }

        return availableTechnicalPermissionsParameter
    }

    private initializeAvailableTechnicalPermissionsParameters(operators: OpOperator[]): void {
        const availableTechnicalPermissionsParameter: BasicParameter = this.setAvailableTechnicalPermissionsBasicParameter(operators)

        this.$scope.availableTechnicalPermissionsParametersOptions = {
            extension: new BasicParametersExtension({
                parameters: [availableTechnicalPermissionsParameter]
            }),
            showEmpty: true,
            onInitialized: (e: IMRParametersInitializedArgs<IBasicParametersExtension>) => {
                this.$scope.availableTechnicalPermissionsParameters = e.component
            }
        }
    }

    private updateAvailableTechnicalPermissionsParameters(operators: OpOperator[]): void {
        if (this.$scope.availableTechnicalPermissionsParameters != null) {
            const availableTechnicalPermissionsParameter: BasicParameter = this.setAvailableTechnicalPermissionsBasicParameter(operators)
            this.$scope.availableTechnicalPermissionsParameters.extension.setParameters([availableTechnicalPermissionsParameter])
            this.$scope.availableTechnicalPermissionsParameters.refresh()
        }
    }

    // #endregion


    // #region Operators Grid 

    private setOperatorsGridOptions(currentOperators: OpOperator[]): void {
        this.$scope.operatorsGridOptions = null
        const technicalPermissonsShow = !this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_GROUP_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.OperatorGroupTechnicalPermissions)
        this.$timeout(() => {
            this.$scope.operatorsGridOptions = {
                addCustomFilters: true,
                columnsDictionary: this.columns,
                dataSource: currentOperators,
                name: this.OPERATOR_GROUP_GRID_NAME,
                idReferenceType: Enums.ReferenceType.IdOperator,
                type: GridTypes.PAGINATED_SMALL,
                masterDetail: {
                    enabled: technicalPermissonsShow,
                    template: this.operatorGroupTechnicalPermissionsService.getOperatorsGridMasterDetailTemplateFunction(currentOperators),
                    autoExpandAll: true
                },
                allowColumnReordering: !this.userSession
                    .getLoggedOperator()
                    .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.OperatorGroupModule),
                buttonsOptions: {
                    enabled: true,
                    toggleDetailsRowsButtonVisible: true
                }
            }
        }, 100)
    }

    // #endregion


    // #region Operators Grid Edit 

    private setOperatorGroupGridEditOptions(operators: OpOperator[]): void {
        this.$scope.operatorGroupGridEditOptions = {
            id: this.referenceObjectId,
            columns: this.columns,
            items: operators.map((operator: OpOperator) => this.gridService.gridObjectFromIOpObject(operator)),
            name: this.OPERATOR_GROUP_GRID_EDIT_NAME,
            popupId: this.$scope.detailsPopupId + 'operatorGroupGrid',
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__GROUPS_EDIT, this.moduleName),
            allowColumnReordering: !this.userSession
                .getLoggedOperator()
                .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.OperatorGroupModule),

            getAvailableDataSourceMethod: this.userSession.
                getDataProvider().Operator.getOperatorFilter,

            buttons: {
                enabled: true
            },

            onSubmit: (added, removed, grid) => {
                const deferred = this.$q.defer<boolean>()

                this.opreatorGroupOperatorsService
                    .saveOperatorsGridEditResult(this.referenceObject, added, removed, grid)
                    .then((savedOperatorGroup: OpOperatorGroup) => {
                        this.onRefresh(savedOperatorGroup)
                        deferred.resolve(true)
                    })
                    .fail(() => {
                        deferred.resolve(false)
                    })

                return deferred.promise
            }
        }
    }

    private onEditOperatorGroup(): void {
        this.$scope.$broadcast(EventsNames.OPEN_GRID_EDIT_POPUP + this.$scope.detailsPopupId + 'operatorGroupGrid')
    }

    // #endregion


    // #region Operator Group Basic Parameters

    private setOperatorGroupBasicParametersOptions(dataTypeInGroup: OpDataTypeInGroup[]): void {
        this.$scope.detailsParametersOptions = {
            useDynamicValues: true,
            dataTypes: dataTypeInGroup,
            referenceType: this.referenceType,
            referenceObject: this.referenceObject
        }
    }

    private onEditOperatorGroupBasicParams(): void {
        this.$scope.$root.$broadcast(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, OperatorGroupHelper.getEditInitParams(this.referenceObject.idOperatorGroup, this.referenceObject))
    }

    // Operator Group Basic Parameters End


    // #region Required Technical Permissions Grid

    private setRequiredTechnicalPermissionsGridOptions(technicalPermissions: OpTechnicalPermission[]): void {
        if (!this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_GROUP_DETAILS_HIDDEN_UI_PROPERTIES, Enums.UIObjectProperties.OperatorTechnicalPermissions, true)) {
            this.$scope.requiredTechnicalPermissionsGridOptions = null

            this.$timeout(() => {
                this.$scope.requiredTechnicalPermissionsGridOptions = {
                    addCustomFilters: true,
                    columnsDictionary: this.technicalPermissionService.getTechnicalPermissionsGridColumns(),
                    dataSource: technicalPermissions,
                    name: this.REQUIRED_TECHNICAL_PERMISSIONS_GRID_NAME,
                    type: GridTypes.PAGINATED_SMALL,
                    allowColumnReordering: !this.userSession
                        .getLoggedOperator()
                        .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.OperatorGroupTechnicalPermissions),
                    buttonsOptions: {
                        enabled: false
                    }
                }
            }, 100)
        }
    }

    // #endregion


    // #region Required Technical Permissions Grid Edit

    private onSaveTechnicalPermissionToOperatorGroup(added: any[], removed: any[]): ng.IPromise<boolean> {
        const deferred = this.$q.defer<boolean>()

        if (this.operatorGroupTechnicalPermissionsService.validateOnSaveTechnicalPermissionToOperatorGroup(added, this.referenceObject.currentOperators, this.requiredTechnicalPermissionsEditGrid)) {
            this.operatorGroupTechnicalPermissionsService
                .saveTechnicalPermissionToGroup(this.userSession.getDataProvider(), this.moduleName, this.referenceObject, added, removed)
                .then((savedObject: OpOperatorGroup) => {
                    this.onRefresh(savedObject)
                    deferred.resolve(true)
                })
                .fail((error: any) => {
                    LogHelper.error(OperatorGroupHelper.LOG_PREFIX, error)
                    deferred.resolve(false)
                })
        } else {
            deferred.resolve(false)
        }

        return deferred.promise
    }

    private setRequiredTechnicalPermissionsGridEditOptions(technicalPermissions: OpTechnicalPermission[]): void {
        this.referenceTypeService.getDictionaryReferenceObjectList(Enums.ReferenceType.IdTechnicalPermission)
            .then((availableTechnicalPermissions: OpTechnicalPermission[]) => {
                this.$scope.requiredTechnicalPermissionsGridEditOptions = {
                    id: this.referenceObjectId,
                    referenceId: this.referenceType,
                    columns: this.technicalPermissionService.getTechnicalPermissionsGridColumns(),
                    items: technicalPermissions,
                    name: this.REQUIRED_TECHNICAL_PERMISSIONS_GRID_EDIT_NAME,
                    popupId: this.$scope.detailsPopupId + 'requiredTechnicalPermissionsGrid',
                    title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__REQUIRED_TECHNICAL_PERMISSIONS_EDIT, this.moduleName),
                    allowColumnReordering: !this.userSession
                        .getLoggedOperator()
                        .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.OperatorGroupTechnicalPermissions),
                    data: availableTechnicalPermissions,
                    onSubmit: (added, removed, inGrid) => this.onSaveTechnicalPermissionToOperatorGroup(added, removed),
                    onGridInitialized: (e, grid) => {
                        this.requiredTechnicalPermissionsEditGrid = grid
                    },
                    buttons: {
                        enabled: true,
                        toggleDetailsRowsButtonVisible: true
                    }
                }
            })
    }

    private onEditRequiredTechnicalPermissions(): void {
        this.$scope.$broadcast(EventsNames.OPEN_GRID_EDIT_POPUP + this.$scope.detailsPopupId + 'requiredTechnicalPermissionsGrid')
    }

    // #endregion


    // #region Confirmation

    private setConfirmationsOptions(): void {
        this.$scope.deleteConfirmationOptions = {
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),

            onConfirmed: () => this.onConfirmDelete()
        }
    }

    // #endregion


    // #region Setup

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this.moduleName) + this.$scope.id,
            (event: ng.IAngularEvent, ...args: any[]) => this.onOpen(args[3])
        )

        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this.moduleName) + this.$scope.id,
            () => this.onClose()
        )

        this.$scope.$on(
            EventsNames.CLOSE_CREATE_EDIT_POPUP,
            (event: ng.IAngularEvent, ...args: any[]) => this.onRefresh(args[0])
        )
    }

    private setOptions(): void {
        this.$scope.options = <DetailsPopupOptions>{
            id: this.$scope.id,

            closeEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this.moduleName),
            delHasPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_GROUP_DEL) ? Activity[Activity.OPERATOR_GROUP_DEL] : null,
            openEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this.moduleName),
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DETAILS, this.moduleName),

            deleteMethod: () => this.onDelete(),
            getAccordionDataMethod: () => this.getAccordionData(),
            getAccordionSelectionMethod: () => this.getAccordionSelection(),
            updateAccordionMethod: (names: any[]) => this.updateAccordions(names)
        }
    }

    private setTemplateConsts(): void {
        this.$scope.OPERATOR_GROUP_COMMON_TAB_NAME = 'OPERATOR_GROUP_COMMON_TAB_NAME'
        this.$scope.OPERATOR_GROUP_ACCORDION_GRID_NAME = 'OPERATOR_GROUP_ACCORDION_GRID_NAME'
        this.$scope.OPERATOR_GROUP_PARAMS_ACCORDION_NAME = 'OPERATOR_GROUP_PARAMS_ACCORDION_NAME'
        this.$scope.OPERATOR_GROUP_REQUIRED_TECHNICAL_PERMISSIONS_ACCORDION_NAME = 'OPERATOR_GROUP_REQUIRED_TECHNICAL_PERMISSIONS_ACCORDION_NAME'
        this.$scope.noActiveAccordions = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoActiveAccordions)
        this.$scope.noDefinedContent = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoDefinedContent)
    }

    // #endregion

    resetData() { this.onClear() }//DO USUNIECIA!!! - zastąpić onClear
    loadData(id: number, objects: any[]) { this.onOpen(null) }//DO USUNIECIA!!! - zastąpić onOpen
    updateData(result: any) { this.onRefresh(result) }//DO USUNIECIA!!! - zastąpić onRefresh
}